export default __webpack_public_path__ + "static/media/3.b6b32493.jpeg";